export default "__VITE_ASSET__5c7266b2__"